/**
 * Homepage page
 */
/* Import section */
import { Link, graphql } from "gatsby"
//import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import Cardarticle from "../components/cardarticle"
import Iframelogin from "../components/iframelogin"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Titledecorative from "../components/titledecorative"
import Bookhalf from "../images/svg/bookhalf.inline.svg"
//import Warning from "../images/svg/warning.inline.svg"
import "../styles/pages/home.scss"

/* Page function declaration */
const IndexPage = ({data}) => {

  const dataPage = data.wpPage
  const dataLastArticle = data.lastArticle.edges

  return (
    <Layout>
      <SEO
        title={dataPage.seo.title}
        description={dataPage.seo.metaDesc}
      />

      <section className="section-login">
        <div className="wrap-maincontent">
          <div className="box-infos">
            <div className="box-message">
              <div className="box-title-message">
                {/*<StaticImage className="icon-boxmsg" src="../images/svg/covid-19_virus_white.svg" Layout="fixed" alt={dataPage.acfPageLogin.titleMessageBox} />*/}
                <Bookhalf />
                <Titledecorative title={dataPage.acfPageLogin.titleMessageBox} />
              </div>
              <div dangerouslySetInnerHTML={{__html:dataPage.acfPageLogin.contentMessageBox}} />
            </div>
            <div className="box-lastarticle">
              <Cardarticle
                typeArticle={dataLastArticle[0].node.categories.nodes[0].name}
                slugTypeArticle={dataLastArticle[0].node.categories.nodes[0].slug}
                titleArticle={dataLastArticle[0].node.title}
                ctaLinkArticle={dataLastArticle[0].node.slug}
                srcImgArticle={dataLastArticle[0].node.acfPostBlogNews.imageArticle}
              />
            </div>
          </div>
          <div className="box-login">
            <div className="box-iframe-login box-iframe">
              <h1><span>{dataPage.title}</span></h1>
              <Iframelogin />
              <p className="link-lostpwd"><Link to="/lost-password/">Forgot Your Password?</Link></p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

/* Query page */
export const query = graphql`
  query {
    wpPage(slug: {eq: "login"}) {
      title
      acfPageLogin {
        titleMessageBox
        contentMessageBox
      }
      seo {
        title
        metaDesc
      }
    }
    lastArticle: allWpPost(limit: 1, sort: {fields: [date], order:DESC}) {
      edges {
        node {
          title
          slug
          acfPostBlogNews {
            imageArticle {
              localFile {
                childImageSharp {
                  gatsbyImageData (layout: CONSTRAINED, width: 1000, formats: [AUTO], aspectRatio: 1.5)
                }
              }
            }
          }
          categories {
            nodes {
              name
              slug
            }
          }
        }
      }
    }
  }
`
/* Export page informations */
export default IndexPage
